module.exports = __webpack_public_path__ + "static/media/buildingConstruction26.413b2f1f.jpg";